var map = {
	"./alien.png": 60333,
	"./bomb.png": 80827,
	"./bowling.png": 37664,
	"./cold_face.png": 74273,
	"./cow_face.png": 93194,
	"./cowboy_hat_face.png": 57134,
	"./dog_face.png": 40919,
	"./fire.png": 69216,
	"./flying_saucer.png": 9021,
	"./frog.png": 24581,
	"./ghost.png": 64009,
	"./hear_no_evil_monkey.png": 10713,
	"./honeybee.png": 25689,
	"./horse.png": 89898,
	"./kangaroo.png": 35933,
	"./oncoming_police_car.png": 62394,
	"./owl.png": 16932,
	"./penguin.png": 20928,
	"./person_juggling.png": 9586,
	"./pig_face.png": 88844,
	"./pile_of_poo.png": 15057,
	"./popcorn.png": 83839,
	"./rabbit_face.png": 88383,
	"./robot.png": 2534,
	"./rocket.png": 78919,
	"./roller_coaster.png": 10166,
	"./sloth.png": 62102,
	"./smiling_face_with_horns.png": 68202,
	"./smiling_face_with_sunglasses.png": 6084,
	"./snowman.png": 95162,
	"./soccer_ball.png": 20573,
	"./spouting_whale.png": 33750,
	"./unicorn.png": 29514,
	"./volcano.png": 97204,
	"./zombie.png": 56375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67218;